<button
  *ngIf="isArrowHide; else arrowButton"
  [style.backgroundColor]="!isFilled ? 'transparent' : 'inherit'"
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{ cursor: isButtonDisabled ? 'default' : 'pointer' }"
  [style.backgroundColor]="isButtonDisabled ? '#7b8d99 !important' : ''"
>
  {{ name }}
</button>

<ng-template #arrowButton>
  <button
    *ngIf="!isReverseButtonEnabled"
    [style.backgroundColor]="!isFilled ? 'transparent' : 'inherit'"
    [ngClass]="ngClass"
    type="button"
    [disabled]="isButtonDisabled"
    [ngStyle]="{ cursor: isButtonDisabled ? 'default' : 'pointer' }"
    [style.backgroundColor]="isButtonDisabled ? '#7b8d99 !important' : ''"
  >
    {{ name }}
    <mat-icon class="button-icon">keyboard_arrow_right</mat-icon>
  </button>

  <button
    *ngIf="isReverseButtonEnabled"
    [style.backgroundColor]="!isFilled ? 'transparent' : 'inherit'"
    [ngClass]="ngClass"
    type="button"
    [disabled]="isButtonDisabled"
    [ngStyle]="{ cursor: isButtonDisabled ? 'default' : 'pointer' }"
    [style.backgroundColor]="isButtonDisabled ? '#7b8d99 !important' : ''"
  >
    <mat-icon class="reverse-button-icon">keyboard_arrow_left</mat-icon>
    {{ name }}
  </button>
</ng-template>
